/* eslint-disable max-len */
import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { EditToolOptionsWrap } from '../styles';
import RecalculateLayoutButton from './RecalculateLayoutBtn';
import { ALL_ACTIONS } from '../../../../../constants';
import { useRefs } from 'contexts/RefContext';
import { getExistingPanelsGroupID } from 'components/tool/utils';
import useScreenDims from 'hooks/useScreenDims';
import { selectIsAnyToolActionActive } from 'store/selectors/toolSelector';
import withPermission from 'components/hoc/withPermission';
import ChangeOrientationButton from './ChangeOrientationBtn';
import RemoveShadingButton from './RemoveShadingButton';
import DeleteFacetToggle from './DeleteFacet/DeleteBtn';
import EditObstructionModeToggle from './EditObstructionBtn';
import withObstructionPermission from 'components/hoc/withObstructionPermission';
import EdgeTool from './EdgeTool';
import { isModeDefault, isInHouseSimulationMode } from '../../../../../util';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';

export default function SolarToolEditOptions() {

	const { selectedRoofIndex, deletedRoofIndexes, roofIndexes, hadTransition } =
		useSelector((state: RootState) => state.toolNewPostions.data);
	const isAnyActionEnabled = useSelector(selectIsAnyToolActionActive);
	const isRecomputing = useSelector(selectIsRecomputing);
	const { allRoofSegs, mode } = useSelector((state: RootState) => state.roofData.data);
	const { useEdgeTypeBasedSetbacks } = useSelector((s: RootState) => s.designSettigs.data);

	const { konvaRef } = useRefs();

	const queriesRunningInBackGround = useQueriesRunningInBackGround();
	const changeOrientationQueryRunning = useQueriesRunningInBackGround(['changeFacetOrientation'], 'mutating');
	const removeShadingQueryInProgress = useQueriesRunningInBackGround(['remove-shading', 'adjust-shading'], 'mutating');

	const isSelectedRoofIndexValid = !!selectedRoofIndex && !deletedRoofIndexes.includes(selectedRoofIndex);
	// facet opteration includes: delte, changeOriention, removeshading
	const isFacetOperationDisabled = isAnyActionEnabled || !isSelectedRoofIndexValid || queriesRunningInBackGround || isRecomputing;

	// diable remove shading, changeorientation when no panels in facet;
	const hasSelectedFacetPanels = !!selectedRoofIndex && !!konvaRef?.current?.findOne(`#${getExistingPanelsGroupID(selectedRoofIndex)}`)?.hasChildren();

	const disableRotateWhenFacetTranformed = (roofIndexes.length > 0);
	const disableChangeOrientationBtn = isFacetOperationDisabled || !hasSelectedFacetPanels || disableRotateWhenFacetTranformed;

	const facet = allRoofSegs.find(rs => rs.id === selectedRoofIndex);
	const isDefaultMode = isModeDefault(mode);
	const isGroundMount = !!facet?.isGroundMount;
	const canRemoveShadingEnabled = isDefaultMode && !isGroundMount && !isInHouseSimulationMode(mode);
	const disableRemoveShading = !hasSelectedFacetPanels || hadTransition;

	const screenDims = useScreenDims();
	const { width: screenWidth } = screenDims;
	const isMobileView = screenWidth < 860;
	const PermittedChangeOrientationBtn = withPermission(ChangeOrientationButton, ALL_ACTIONS.ROTATE_ROOF_SEGMENTS);
	const PermittedRemoveShadingBtn = withPermission(RemoveShadingButton, ALL_ACTIONS.REMOVE_ROOF_SEGMENT_SHADING);
	const PermittedDeleteFacetBtn = withPermission(DeleteFacetToggle, ALL_ACTIONS.EDIT_ROOF_SEGMENTS);
	const PermittedResetLayout = withPermission(RecalculateLayoutButton, ALL_ACTIONS.RESET_LAYOUT);
	const PermittedEditObs = withObstructionPermission(EditObstructionModeToggle);
	const PermittedEdgeTool = withPermission(EdgeTool, ALL_ACTIONS.UPSERT_ROOF_SEGMENT_EDGES);

	return (
		<>
			{<PermittedChangeOrientationBtn
				isMobileView={isMobileView}
				disableChangeOrientationBtn={disableChangeOrientationBtn}
				changeOrientationQueryRunning={changeOrientationQueryRunning}
			/>}
			<PermittedDeleteFacetBtn/>
			<PermittedResetLayout/>
			<PermittedEditObs canRemoveShadingEnabled={canRemoveShadingEnabled}/>
			{ useEdgeTypeBasedSetbacks && <PermittedEdgeTool/> }

			{canRemoveShadingEnabled && (
				<PermittedRemoveShadingBtn
					isMobileView={isMobileView}
					disableRemoveShading={disableRemoveShading}
					removeShadingQueryInProgress={removeShadingQueryInProgress}
					facet={facet}
				/>
			)}
		</>

	);
}
